import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class HeaderTitleService {
  headerTitle = [
    { id: 1, icon: 'dashboard', title: 'Dashboard' },
    { id: 2, icon: 'assignment', title: 'Cases' },
    { id: 3, icon: 'person', title: 'Users ' },
    { id: 4, icon: 'bar_chart', title: 'Reports ' },
    { id: 5, icon: 'today', title: 'Calendar' },
    { id: 6, icon: 'check_circle', title: 'ToDo' },
    { id: 7, icon: 'payment', title: 'Payments ' },
    { id: 8, icon: 'settings', title: 'Settings ' },
    { id: 9, icon: 'support', title: 'Help' }
  ];
  subject: Subject<any> = new BehaviorSubject('');

  constructor() {}
  sendHeader(icon: string, title: string) {
    this.subject.next({ text: title, icon: icon });
  }

  clearHeader() {
    this.subject.next();
  }

  getHeader(): Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/header-title.service.ts